import util from '../util'

let controller = 'MigracaoContaLote'

export default Object.assign({}, util.GetCrud(controller, ['post', 'put', 'get', 'getall', 'persist', 'delete']), {
  ObterLoteEmProcessamento: function () {
    return util.Axios.Get(controller + '/pendente')
  }
})
